<script>
	import Quote from './Quote.svelte'
	import Order from './Order.svelte'

	let showTooltip = false;
	let showQuote = false;
	let showOrder = false;
	let page = 1;
	let pct;
	// let url = 'https://3w5h07tech.execute-api.us-west-2.amazonaws.com/prod';
	let url = 'https://9g9ffmp8x1.execute-api.us-west-2.amazonaws.com/prod/';
	// let url = 'https://k2y2eh9x62.execute-api.us-west-2.amazonaws.com/pctsf';
	let data_response;
	let loading;

	function decrement() {
		if (page > 0) {
			page--;
		}
		route();
	}
	function increment() {
		page++;
		route();
	}

	function route() {
		// console.log("route page",page);
		if (page === 0) {
			showQuote = false;
			showOrder = false;
		}
		if (page === 1) {
			showQuote = false;
			showOrder = false;
		}
		if (page === 2) {
			showQuote = true;
			showOrder = false;
		}
		if (page === 3) {
			showQuote = false;
			showOrder = true;
		}
	}

	function handleQuote() {
		loading = true;
		if(showQuote) {
			showQuote = false;
			loading = false;
		} else {
			pct = document.querySelector("#pct").value;
			let data = {
        pct,
        address: 'sample address',
        city: 'sample city',
        state: 'sample state',
        "zip code": 'zip code',
        country: 'country',
        company: 'sample company',
				website: 'http://patenttrademarkblog.com/pct/declaration.html',
				// generate: '1'
      };

			if(!data_response || (data_response && data_response.hasOwnProperty('pct') && data_response.pct != pct )) {
				fetchThis(url,data);
			} else {
				//showQuote = true;
				increment();
				loading = false;
			}
		}
	}

	function handleBack() {
		loading = false;
		// showQuote = false;
		// showOrder = false;
		decrement();
	}

	function fetchThis(url, data) {
		console.log("data",data);
		fetch(url, {
			method: "POST",
			body: JSON.stringify(data),
			headers: {
				"Content-Type": "text/plain"
			}
		}).then(res => res.json())
			.then(response => {
				console.log("response", response);
				if (response.hasOwnProperty("errorType")) {
					alert(response["errorMessage"]);
				}
				if (response.hasOwnProperty("status")) {
					if (response.status === 'processing') {
						let arn = response.executionArn;
						fetchThis('https://nen5r3brn1.execute-api.us-west-2.amazonaws.com/pctstatus',{arn})
					}
				}
				if (response.hasOwnProperty("status")) {
					if (response.status === 'RUNNING') {
						let arn = response.executionArn;

						setTimeout(function(){
							fetchThis('https://nen5r3brn1.execute-api.us-west-2.amazonaws.com/pctstatus',{arn})
						}, 6000);

					}
				}
				if (response.hasOwnProperty("status")) {
					if (response.status === 'SUCCEEDED') {
						let arn = response.executionArn;
						fetchThis('https://9g9ffmp8x1.execute-api.us-west-2.amazonaws.com/prod',{pct})
					}
				}
				if (response.hasOwnProperty("status")) {
					if (response.status === 'missing') {
						let data = {
			        pct,
			        address: 'sample address',
			        city: 'sample city',
			        state: 'sample state',
			        "zip code": 'zip code',
			        country: 'country',
			        company: 'sample company',
							website: 'http://patenttrademarkblog.com/pct/declaration.html',
							// generate: '1'
			      }
						// console.log("data",data);
						fetchThis('https://k2y2eh9x62.execute-api.us-west-2.amazonaws.com/pctsf',data)
					}
				}
				if (response.hasOwnProperty("title")) {
					data_response = response;
					//showQuote = true;
					increment();
					loading = false;
				}
			})
			.catch(() => {
				console.log("Can’t access " + url + " response. Blocked by browser?");
				alert("Response error, please retry");
				loading = false;
			});
	}

	function handleAccept() {
		loading = false;
		//showOrder = true;
		increment();
		//showQuote = false;
	}

	function handleTooltip() {
		if(showTooltip) {
			showTooltip = false;
		} else {
			showTooltip = true;
		}
	}
</script>

<div class:loading="{loading === true}">
	<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
	  <circle cx="50" cy="50" r="45"/>
	</svg>
</div>
	<main>
		{#if !showQuote && !showOrder}
		<h1>File your U.S. National Stage Application</h1>
				<div class="form-group" id="pct_field">
					<label for="pct">Enter PCT Application number</label>
					<input type="text" class="form-control" name="pct" id="pct" placeholder="" value="PCT/US2018/017247"/>
					<div class="leftAlign">
						<div>I acknowledge that:</div>
						<div class="tooltipText"><span>- the applicant is a small entity</span><span on:click={handleTooltip} class="tooltip">?</span></div>
						<div class="tooltipPopup" class:show = {showTooltip}>
							A small entity may be individual inventors, a small business with fewer than 500 employees, or nonprofit organization regardless of size (e.g., universities).
						</div>
						<div><span> - signed forms must be emailed to Innovation Capital Law Group (processing@icaplaw.com) by 9am Pacific (California time) at least two business days before the US national stage deadline.  Otherwise we will file without executed documents which will incur additional costs.</span></div>
					</div>
				</div>
				<div class="form-group" id="submit_field">
					<button on:click={handleQuote}>Submit</button>
				</div>
				(Please wait up to 1 minute for us to gather your PCT application details. Do not close this window.)
		{/if}
		{#if showQuote}
			<Quote response={data_response}/>
			<div class="buttonDiv">
				<div>
					<button on:click={handleBack}>Back</button>
				</div>
				<div>
					<button on:click={handleAccept}>Start Order</button>
					<p>You can review and finalize your order on the next page.  We will initially charge our non-refundable fees of $790.  After we receive confirmation of payment, our team will email you documents for signature.  A separate payment of $830 for the government fee will be required before filing.<br><br></p><p>For Agents, please email <a href="mailto:processing@icaplaw.com">processing@icaplaw.com</a> to request your firm’s passcode for placing orders.</p>
				</div>
			</div>

		{/if}

		{#if showOrder}
			<Order pct={pct} response={data_response} handleBack={handleBack}/>
		{/if}

	</main>

<style>
	.loading {
		cursor: wait;
		z-index: 100;
		position: absolute;
		left: 0;
		top: 0;
		bottom: 0;
		right: 0;
		background: #e9e9e9;
		opacity: .9;
		display:block;
	}
	main {
		text-align: center;
		padding: 1em;
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 2em;
		font-weight: 100;
	}

	@media (min-width: 320px) {
		h1 {
			font-size: 2em;
		}
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}

	.leftAlign {
		text-align:left;
		font-size: 16px;
		line-height: 24px;
	}
	.tooltipText {
		display: grid;
		grid-template-areas: "a b";
		align-items: center;
		justify-content: start;
	}
	.tooltip {
		display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    background-color: #8a8f93;
    color: #fff;
		margin: 0px 5px;
	}
	.buttonDiv {
		display: grid;
		grid-template-areas: "a b";
		grid-template-columns: 20% 80%;
	}
	.buttonDiv p {
		margin: 0;
	}
	.tooltipPopup {
		z-index: 10;
		box-shadow: 0 2px 8px 0 rgba(0,0,0,.2);
		background: #fff;
		border-radius: 12px;
		padding: 20px;
		width: 300px;
		height: auto;
		transition: opacity .3s ease-in-out;
		margin: auto;
		text-align: center;
		position: absolute;
		left: 10%;
		display:none;
	}
	.show {
		display:block;
	}

	svg {
		display:none;
  	animation: 2s linear infinite svg-animation;
  	max-width: 100px;
		position:absolute;
		left: 50%;
		top: 50%;
		opacity: 1;
	}
	.loading svg {
		display:block;
	}
	@keyframes svg-animation {
	  0% {
	    transform: rotateZ(0deg);
	  }
	  100% {
	    transform: rotateZ(360deg)
	  }
	}

circle {
  animation: 1.4s ease-in-out infinite both circle-animation;
  display: block;
  fill: transparent;
  stroke: #2f3d4c;
  stroke-linecap: round;
  stroke-dasharray: 283;
  stroke-dashoffset: 280;
  stroke-width: 10px;
  transform-origin: 50% 50%;
}

@keyframes circle-animation {
  0%,
  25% {
    stroke-dashoffset: 280;
    transform: rotate(0);
  }

  50%,
  75% {
    stroke-dashoffset: 75;
    transform: rotate(45deg);
  }

  100% {
    stroke-dashoffset: 280;
    transform: rotate(360deg);
  }
}
</style>
